<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <wj-tab-panel [selectedIndex]="0">
                <wj-tab>
                    <a>{{ 'common.search' | transloco }}</a>
                    <div class="card">
                        <div class="card-header">
                            {{ 'common.search' | transloco }}
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_id' | transloco }}</label>
                                <div class="col-md-2">
                                    <input type="number" [(ngModel)]="predicate.id" class="form-control" [placeholder]="'admin.item_id' | transloco">
                                </div>
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.event_date' | transloco }}</label>
                                <div class="col-md-2">
                                    <wj-input-date style="width:100%;" style="width:100%;" [(value)]="predicate.eventDate" [format]="'yyyy/MM/dd'" [isRequired]="false" [placeholder]="'admin.event_date' | transloco"></wj-input-date>
                                </div>
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.lane' | transloco }}</label>
                                <div class="col-md-2">
                                    <select class="form-control" [(ngModel)]="predicate.lane">
                                        <option value="">-</option>
                                        <option *ngFor="let item of optionLane" [value]="item.value">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_category' | transloco }}</label>
                                <div class="col-md-2">
                                    <select class="form-control" [(ngModel)]="predicate.category">
                                        <option value="">-</option>
                                        <option *ngFor="let item of optionCategory" [value]="item.value">{{ item.value }}</option>
                                    </select>
                                </div>
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.auction_result' | transloco }}</label>
                                <div class="col-md-2">
                                    <select class="form-control" [(ngModel)]="predicate.auctionResult">
                                        <option value="">-</option>
                                        <option *ngFor="let item of optionAuctionResult" [value]="item.value">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_name' | transloco }}</label>
                                <div class="col-md-2">
                                    <input type="text" [(ngModel)]="predicate.name" class="form-control" [placeholder]="'admin.item_name' | transloco">
                                </div>
                                <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_description' | transloco }}</label>
                                <div class="col-md-2">
                                    <input type="text" [(ngModel)]="predicate.description" class="form-control" [placeholder]="'admin.item_description' | transloco">
                                </div>
                                <div class="col-md-2">
                                    <button (click)="search()" class="btn btn-primary btn-block">{{ 'common.search' | transloco }}</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="resetPredicate()" class="btn btn-success btn-block">{{ 'admin.reset' | transloco }}</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <wj-multi-row *ngIf="screenWidth >= 768" #historyGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="histories">
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='method' [header]="'admin.order_method' | transloco" [width]="150">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='historyDate' [header]="'admin.bid_date_time' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd HH:mm:ss'" [width]="150">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='buyer.memberName' [header]="'admin.buyer' | transloco" [width]="150">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='increase' [header]="'admin.increment' | transloco" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='price' [header]="'admin.bid_price' | transloco" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='item.id' [header]="'admin.item_id' | transloco" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='item.category' [header]="'admin.item_category' | transloco" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='item.name' [header]="'admin.item_name' | transloco" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='item.description' [header]="'admin.item_description' | transloco" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                        <wj-multi-row-cell-group>
                                            <wj-multi-row-cell binding='item.startPrice' [header]="'admin.start_price' | transloco" [dataType]="'Number'" [width]="80">
                                            </wj-multi-row-cell>
                                        </wj-multi-row-cell-group>
                                    </wj-multi-row>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
                <wj-tab>
                    <a>{{ 'admin.bid_history_info' | transloco }}<span *ngIf="history['@rid'] == '#-1:-1'">({{ 'common.new' | transloco }})</span></a>
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-2">
                                    <button (click)="createNew()" type="button" class="btn btn-block btn-primary">{{ 'admin.create_new' | transloco }}</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="editHistory()" type="button" class="btn btn-block btn-primary">{{ 'common.edit' | transloco }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <fieldset [disabled]="mode == 'view'">
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.order_method' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <select class="form-control" [(ngModel)]="history.method">
                                                            <option *ngFor="let item of optionMethod" [value]="item.value">{{ item.value }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.bid_date_time' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <wj-input-date-time style="width:100%;" style="width:100%;" [(value)]="history.historyDate" [format]="'yyyy/MM/dd HH:mm:ss'" [isRequired]="true" [placeholder]="'admin.bid_date_time' | transloco"></wj-input-date-time>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.buyer' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <wj-auto-complete #buyerAutoComplete [(ngModel)]="history.buyer" style="width:100%;" [placeholder]="'admin.buyer' | transloco" [displayMemberPath]="'memberName'" [itemsSourceFunction]="getBuyer"></wj-auto-complete>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.bid_price' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <input type="number" [(ngModel)]="history.price" class="form-control" [placeholder]="'admin.bid_price' | transloco">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.item' | transloco }}</label>
                                                    <div class="col-md-6">
                                                        <wj-auto-complete #itemAutoComplete [(ngModel)]="history.item" style="width:100%;" [placeholder]="'admin.item' | transloco" [displayMemberPath]="'name'" [itemsSourceFunction]="getItem"></wj-auto-complete>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                        <div *ngIf="mode == 'edit'" class="card-footer">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <button (click)="saveHistory()" class="btn btn-primary btn-block">{{ 'common.save' | transloco }}</button>
                                                </div>
                                                <div class="col-md-6">
                                                    <button (click)="cancelHistory()" class="btn btn-danger btn-block">{{ 'common.cancel' | transloco }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-footer">
                    <div style="float:left; min-width: 150px;">
                        <wj-menu [(value)]="histories.pageSize" [header]="'admin.page_size' | transloco">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-navigator [cv]="histories"></wj-collection-view-navigator>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-pager [cv]="histories"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

